import api from "../../axios/axios";
import { IRoute } from "./ITerminal";

const getTerminalAsync = async (): Promise<IRoute> => {
  const response = await api.get<IRoute>("/api/v1/Terminal");
  return response.data;
};

export default getTerminalAsync;
